/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["default-preview{display:block;max-width:380px;max-height:150px}default-preview .panel{display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#fff;color:rgba(0,0,0,.87);border-radius:4px;width:100%;height:100%;margin:auto;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)}default-preview .panel .message{font-size:1.8rem;margin-bottom:15px}default-preview .panel .mat-raised-button{display:block}"];
export { styles as styles };
